import BASE_CONFIG from '@/common/appConfig';

export type AppMode = 'default' | 'federated';

export default function getAppMode(): AppMode {
  if (BASE_CONFIG.isFederated) {
    return 'federated';
  }
  return 'default';
}
